import { AppBar as KAppBar } from "@progress/kendo-react-layout";

import "./AppBar.scss";

import type { AppBarProps as KAppBarProps } from "@progress/kendo-react-layout";

export const AppBar = function render(props: KAppBarProps) {
  const { className, ...otherProps } = props;
  return <KAppBar className={`tc-appbar ${className}`} {...otherProps} />;
};
